export default __webpack_public_path__ + "static/media/img3.3e5b6a47.svg";